import { RootState } from 'store';
import { IKioskState } from 'types/kiosk/IKioskState';
import { KioskStatus } from 'types/kiosk/KioskStatus';
import { TKioskSession } from 'types/kiosk/TKioskSession';

export const kioskStateSelector = (state: RootState): IKioskState => state.kiosk;
export const kioskStatusSelector = (state: RootState): KioskStatus => state.kiosk.status;
export const isKioskActiveSelector = (state: RootState): boolean => state.kiosk.status === KioskStatus.ACTIVE;

/** True while the kiosk owns the shell — both ACTIVE and the launch-time RESUMING state. */
export const isKioskLockedSelector = (state: RootState): boolean =>
  state.kiosk.status === KioskStatus.ACTIVE || state.kiosk.status === KioskStatus.RESUMING;

export const kioskSessionSelector = (state: RootState): TKioskSession | null => state.kiosk.session;
export const boundLocationNameSelector = (state: RootState): string | null => state.kiosk.session?.locationName ?? null;
export const kioskLoadingSelector = (state: RootState): boolean => state.kiosk.loading;
export const kioskErrorSelector = (state: RootState): string | null => state.kiosk.error;
